import {useCallback} from 'react';
import {IconButton} from 'components/button';
import type {CompareActionCompoent} from './types';
import {useDataFormContext} from '../contexts';
import {usePartChangeActionTooltip} from '../hooks/usePartChangeActionTooltip';

export const DataFormCompareReplaceValue: CompareActionCompoent = ({
  valuePath,
  part,
  disabled,
}) => {
  const {setApprovedValue} = useDataFormContext();
  const tooltip = usePartChangeActionTooltip('replace', part);

  const handleApprove = useCallback(() => {
    console.log('handleApprove');
    setApprovedValue(valuePath, 'replace', undefined, undefined);
  }, [setApprovedValue, valuePath]);

  return (
    <IconButton
      icon="Swap"
      onClick={handleApprove}
      tooltip={tooltip}
      disabled={disabled}
    />
  );
};
